import React from 'react';
import PropTypes from 'prop-types';

export function Player(props) {
  const clonePlayer = () => {
    return React.cloneElement(props.player, {
      ...props.player.props,
    });
  };

  return clonePlayer();
}

Player.propTypes = {
  /**
   * returns component to be rendered as animation player
   */
  player: PropTypes.element,
};

Player.defaultProps = {
  player: <div>PLAYER ERROR</div>,
};
